import {
  queryDistributionList,
  generateOnlineDi,
  queryParentAttributeByTyp,
  queryChildAttributeByPid,
  addChannel,
  queryBusinessContentList,
  batchAddChannel,
  queryDictionaries
} from "../../../../api/contentDistribution";
import {copyUrl, getQRCode} from "../../../../utils/tools";
import {listTenantContentLabels} from "../../../../api/man";
import {queryBusiness, queryDiseaseLibraryName} from "../../../../api/questionsLibrary";
import {
  querySource,
} from "@/api/questionsLibrary";

// 获取线上链接
export function getOnlineLinks(row, cope, that) {
  generateOnlineDi({
    contentId: row.id,
    contentType: row.articleType
  }).then(res => {
    if (res) {
      that.mUrl = res.mUrl
      if (cope) {
        copyUrl()
      }
      if (!cope) {
        getQRCode(that.mUrl, (url) => {
          that.qrCode = url;
          that.dialogPreVisible = true;
        });
      }
    }
  })
}
// 获取线上链接
export function getOnlineLinksAsync(row, cope, that) {
  return new Promise((resolve, reject) => {
    generateOnlineDi({
      contentId: row.id,
      contentType: row.articleType
    }).then(res => {
      if (res) {
        that.mUrl = res.mUrl;
        resolve(res.mUrl);
        if (!cope) {
          getQRCode(that.mUrl, (url) => {
            that.qrCode = url;
            that.dialogPreVisible = true;
          });
        }
      } else {
        reject(res);
      }
    })
  });

}

// 添加频道
export function addChannels(val, that) {
  that.multipleSelection = []
  that.tenantId = val.row.id
  that.multipleSelection.push(Number(val.row.id))
  that.dialogTableVisible = true
  that.channelType = 1
}

// 批量添加
export function addBatchChannel(that) {
  if (that.multipleSelection.length == 0) {
    that.$message.error('请选择要添加频道的内容');
    return false
  }
  that.dialogTableVisible = true
  that.channelType = 2
}

// el-dialog打开回调
export function oneDialog(that) {
  that.$nextTick(() => {
    that.$refs.businessColumnChannel.getBusiness()
  })
}

// 批量添加频道提交
export function addChannelSubmission(that) {
  that.$refs.businessColumnChannel.getBizListData(that.form);
  let request;
  if (that.multipleSelection.length == 1) {
    if (that.channelType == 1) {
      request = addChannel
    }
    if (that.channelType == 2) {
      request = batchAddChannel
    }
  } else {
    request = batchAddChannel
  }
  console.log(request)

  request({
    contentIds: that.multipleSelection,
    tenantId: that.$commonJs.getTenantId(),
    contentChannels: that.form.contentChannels,
  }).then(res => {
    if (res) {
      that.$message({
        message: '添加频道成功！',
        type: 'success'
      });
      that.multipleSelection = []
      that.tenantId = ''
      that.dialogTableVisible = false;
      that.getDistributionListData();
      that.$refs.multipleTable.clearSelection();
    }
  }).catch(err => {
    that.$message.error(err.msg);
  })
}

// 批量添加频道取消
export function cancelChannelSubmission(that) {
  that.dialogTableVisible = false;
  that.multipleSelection = []
  that.tenantId = ''
  that.$refs.multipleTable.clearSelection();
}

// 搜索内容属性处理
export function searchDataProcessing(that) {
  that.contentAttributes = []
  console.log('来这了1111----->', that.selectList.qualityList);
  // 内容性质
  if (that.selectList.nature&&that.selectList.nature != '') {
    that.dataTraversal(that.natureList, that.selectList.nature)
  }
  // 文章级别
  if (that.selectList.level&&that.selectList.level != '') {
    that.dataTraversal(that.select[15].levelList, that.selectList.level)
  }
  // 分发范围
  if (that.selectList.range && that.selectList.range != '') {
    that.dataTraversal(that.rangeList, that.selectList.range)
  }
  // 分发范围
  if (that.selectList.quality && that.selectList.quality != '') {
    console.log('来这了----->', that.selectList.quality, that.selectList.qualityList);
    that.dataTraversal(that.qualityList, that.selectList.quality)
  }

}

// 获取列表数据
export function getDistributionListData(requestMethod, that, num) {
  if (num == '1') {
    that.paginationDataProduct.currentPage = 1;
  }
  let arr = []
  if (that.selectList.articleLabel) {
    that.selectList.articleLabel.map(item => {
      // if (item.length == 2) {
      //   arr.push(item[1])
      // } else if (item.length == 3) {
      //   arr.push(item[2])
      // } else if (item.length == 4) {
      //   arr.push(item[3])
      // } else if (item.length == 5) {
        arr.push(item[item.length - 1])
      // }
    })
  }
  if(that.selectList.businessLabel) {
    that.selectList.businessLabel.map(item => {
      // if (item.length == 2) {
      //   arr.push(item[1])
      // } else if (item.length == 3) {
      //   arr.push(item[2])
      // } else if (item.length == 4) {
      //   arr.push(item[3])
      // } else if (item.length == 5) {
        arr.push(item[item.length - 1])
      // }
    })
  }
  let contentIndexIds = [];
  if (that.selectList?.contentIndexIds?.length > 0) {
    contentIndexIds = that.selectList?.contentIndexIds?.map((item) => item[item.length -1]);
  }
  that.loading = true
  requestMethod({
    tenantId: Number(that.$commonJs.getTenantId()),
    id: that.selectList.articleId || null,// 文章id
    title: that.selectList.articleKeyWord || null, // 关键词
    keyWords: that.selectList.keyWords || null,
    nickName: that.selectList.nickname || null, // 写手昵称
    userPin: that.selectList.writerPin || null, // 写手pin
    originalAuthorName: that.selectList.doctorName || null, // 医生姓名
    originalAuthorUnit: that.selectList.hospital || null, // 医院名称
    originalAuthorDepart: that.selectList.department || null, // 科室名称
    articleTypes: that.selectList.articleType&&Number(that.selectList.articleType) ? [Number(that.selectList.articleType)] : [], // 内容类型
    startSubmitTime: that.selectList.submissionTime[0] || null, // 开始时间
    endSubmitTime: that.selectList.submissionTime[1] || null, // 结束时间
    startAuditTime: that.selectList.auditTime && that.selectList.auditTime[0] || null,
    endAuditTime: that.selectList.auditTime && that.selectList.auditTime[1] || null,
    diseaseIds: that.selectList.diseaseLabel ? [that.selectList.diseaseLabel] : [], // 疾病id,
    businessIds: that.selectList.business || [], // 业务id
    contentCategoryIds: that.selectList.categoryId || [], // 栏目id
    contentChannelIds: that.selectList.channelId || [], // 频道id
    articleSources: that.selectList.isOriginal&&Number(that.selectList.isOriginal) ? [Number(that.selectList.isOriginal)] : [], // 来源
    badge:  that.selectList.featuredArticle != '全部' ?  that.selectList.featuredArticle|| null : null,
    auditUser:  that.selectList.auditUser || null,
    isDoctor: that.selectList.isDoctor&&Number(that.selectList.isDoctor) ? that.selectList.isDoctor  : null,
    contentAttributes: that.contentAttributes || [], // 内容属性
    contentDiseasesNotNull: that.selectList.contentDiseasesNotNull&&that.selectList.contentDiseasesNotNull != '全部' ? that.selectList.contentDiseasesNotNull : null,
    categoryRelationIds: that.selectList.categoryRelationId ? [that.selectList.categoryRelationId] : [],
    contentLabelIds: arr, // 标签id
    page: that.paginationDataProduct.currentPage || num,
    pageSize: that.paginationDataProduct.pageSize,
    contentIndexIds, // 索引
    sortOrderParams: that.selectList.sortOrderParams,
    sourceTypes: that.selectList.questionSource ? that.selectList.questionSource.filter((item) => item != '全部') : null, // 问答来源
    contentMetricsParam: {
      videoType: that.selectList.videoType != '全部' ? that.selectList.videoType : null,
      videoDurationGte:  that.selectList.videoDuration.startNum,
      videoDurationLte:  that.selectList.videoDuration.endNum,
      paragraphWordCountGte: that.selectList.videoText.startNum,
      paragraphWordCountLte: that.selectList.videoText.endNum
    }
  })
    .then(res => {
      if (res) {
        that.tableData = res.data
        that.paginationDataProduct.currentPage = res.pageNo
        that.paginationDataProduct.pageSize = res.pageSize
        that.paginationDataProduct.total = res.totalCount
        that.loading = false
      }
    })
    .catch(err => {
      that.loading = false
      console.log(err)
    })
}

// 清空
export function empty(that) {
  Object.keys(that.selectList).map(item => {
    that.selectList[item] = ''
  })
  that.selectList.isOriginal = ''
  that.select.map(item => {
    if (['videoDuration','videoText'].includes(item.prop)){
      that.selectList[item.prop] = {};
    }
    if (item.prop == 'categoryId') item.List = []
    if (item.prop == 'channelId') item.List = []
    if (item.prop == 'chanlevelnelId') item.List = []
    if (item.prop == 'level') item.List = []
    if (item.prop == 'diseaseLabel') item.List = []
  })
  that.contentAttributes = []
  that.getDistributionListData()
}

// 弹窗关闭事件
export function closeDialog(that) {
  that.multipleSelection = []
  that.tenantId = ''
  that.$refs.multipleTable.clearSelection();
}

// 获取通用标签
export function getGeneralLabel(that) {
  listTenantContentLabels({
    tenantId: that.$commonJs.getTenantId(),
    labelType: 1
  }).then(res => {
    console.log('listTenantContentLabels- --获取通用标签', res);
    if (res && res.data) {
      let arr = res.data.map(item => {
        item.disabled = true
        if (item.contentLabels.length > 0) {
          item.contentLabels.map(twoLevel => {
            if (twoLevel.contentLabels.length > 0) {
              twoLevel.contentLabels.map(threeLevel => {
                if (threeLevel.contentLabels.length > 0) {
                  threeLevel.contentLabels.map(fourLevel => {
                    // if (fourLevel.contentLabels.length == 0) {
                    fourLevel.contentLabels = undefined
                    // }
                  })
                } else {
                  threeLevel.contentLabels = undefined
                }
              })
            } else {
              twoLevel.contentLabels = undefined
            }
          })
        } else {
          item.contentLabels = undefined
        }
        return item
      })
      that.articleLabels = arr;
      that.select.map(item => {
        if (item.prop == 'articleLabel') item.List = arr
      })
    }
  })
}

// 获取自定义标签
export function getBusinessLabel(that) {
  listTenantContentLabels({
    tenantId: that.$commonJs.getTenantId(),
    contentId: '14618949'
    // labelType: 2
  }).then(res => {
    console.log('listTenantContentLabels- --获取自定义标签', res);
    if (res && res.data) {
      let arr = res.data.map(item => {
        item.disabled = true
        if (item.contentLabels.length > 0) {
          item.contentLabels.map(twoLevel => {
            if (twoLevel.contentLabels.length > 0) {
              twoLevel.contentLabels.map(threeLevel => {
                if (threeLevel.contentLabels.length > 0) {
                  threeLevel.contentLabels.map(fourLevel => {
                    // if (fourLevel.contentLabels.length == 0) {
                    fourLevel.contentLabels = undefined
                    // }
                  })
                } else {
                  threeLevel.contentLabels = undefined
                }
              })
            } else {
              twoLevel.contentLabels = undefined
            }
          })
        } else {
          item.contentLabels = undefined
        }
        return item
      })
      that.businessLabels = arr;
      that.select.map(item => {
        if (item.prop == 'businessLabel') item.List = arr
      })
    }
  })
}

// 查询疾病库名称
export function getDiseasesData(val, that) {
  queryDiseaseLibraryName({
    tenantId: that.$commonJs.getTenantId(),
    diseaseName: val
  })
    .then(res => {
      if (res) {
        console.log('来这了',res);
        let arr = res.data?.map(item => {
          return {value: item.diseaseId, label: item.diseaseName}
        })
        that.select.map(item => {
          console.log('来这了',item, '=======>');
          if (item.prop == 'diseaseLabel') {
            console.log('来这了',item);
            item.List.splice(0, item.List.length)
            item.List = arr
          }
        })
      }
    })
    .catch(err => {
      console.log(err)
    })
}

// 查询所属业务
export function getBusiness(that) {
  queryBusiness({tenantId: that.$commonJs.getTenantId()})
    .then(res => {
      if (res) {
        let arr = res.map(item => {
          return {value: item.id, label: item.name}
        })
        that.select.map(item => {
          if (item.prop == 'business') item.List = arr
        })
      }
    })
    .catch(err => {
      console.log(err)
    })
}

// 查询内容性质
export function getContentNature(that) {
  queryParentAttributeByTyp({
    attributeType: 5
  }).then(res => {
    if (res) {
      let arr = res.map(item => {
        return {value: item.id, label: item.desc}
      })
      that.select.map(item => {
        if (item.prop == 'nature') item.List = arr
      })
      that.natureList = res
    }
  })
}

// 查询分发范围
export function getDistributionScope(that) {
  queryChildAttributeByPid({
    parentId: 26
    // attributeType: 25
  }).then(res => {
    if (res) {
      let arr = res.map(item => {
        return {value: item.id, label: item.desc}
      })
      // arr.unshift({value: 10000, label: "全部"})
      that.select.map(item => {
        // console.log(item, 'totototototototrrrr');
        if (item.prop == 'range'){
          item.List = arr;
          // console.log(item, 'gogogogog');
        }
      })
      that.allSearchList?.map((item) => {
        item?.selectItems?.map((subItem) => {
            if (subItem.cfgID == 3003) {
              item.List = arr;
            }
        })
    })
      that.rangeList = res
      console.log('queryChildAttributeByPid', '来这了----->',that.rangeList);
    }
  })
}
// 查询内容质量
export function getContentQuailty(that) {
  queryDictionaries({
    tenantId: that.$commonJs.getTenantId(),
    typeList: [29],
  }).then(res => {
    if (res) {
      let arr = res.map(item => {
        return {value: item.id, label: item.desc}
      })
      // arr.unshift({value: 10000, label: "全部"})
       that.select.map(item => {
        if (item.prop == 'quality') item.List = arr
      })

      that.qualityList = res
      // console.log('qualityList', '来这了----->',that.qualityList);
    }
  })
}

// 表格多选
export function handleSelectionChange(val, that) {
  that.multipleSelection = []
  val.map(item => {
    that.multipleSelection.push(item.id);
  })
}

// 跳转存储信息
export function storeInformation(type, that) {
  console.log(type, that, '存储------------------------->');
  let page = JSON.stringify(that.paginationDataProduct)
  let selectStr = JSON.stringify(that.selectList)
  let selecrData = JSON.stringify(that.select)
  if (type == 1) {
    sessionStorage.setItem('disBuPage', page) // 存入页码数据
    sessionStorage.setItem('disBuSelectList', selectStr) // 存入筛选数据
    sessionStorage.setItem('disBuSelectData', selecrData) // 存入筛选选择数据
  } else {
    sessionStorage.setItem('businesBuPage', page) // 存入页码数据
    sessionStorage.setItem('businesSelectList', selectStr) // 存入筛选数据
    sessionStorage.setItem('businesSelectData', selecrData) // 存入筛选选择数据
  }
}

export function initializeJump(that) {
  that.paginationDataProduct = {
    total: 0,
    currentPage: 1,
    pageSize: 10
  }
  Object.keys(that.selectList).map(item => {
    // that.selectList[item] = ''
  })
  that.selectList.articleLabel = []
  that.selectList.businessLabel = []
  that.selectList.submissionTime = []
  that.selectList.business = []
  that.selectList.categoryId = []
  that.selectList.channelId = []
  that.select.map(item => {
    if (item.prop == 'categoryId') item.List = []
    if (item.prop == 'channelId') item.List = []
    if (item.prop == 'chanlevelnelId') item.List = []
    if (item.prop == 'level') item.List = []
    if (item.prop == 'diseaseLabel') item.List = []
  })
}

export function getContentSources(that){
     // 问答来源查询
     querySource({ tenantId: that.$commonJs.getTenantId(), contentType: that.contentType }).then(res => {
      that.questionFrom = res.map(item => ({ value: item.code, label: item.desc }));
      res && that.select.map(item => {
        if (item.prop == 'questionSource') {
          item.List =  that.questionFrom;
          // this.selectList[item.prop] = ['全部', ...res.map(subItem => subItem.code)];
        }
      });
  }).catch(err => {
    console.log('获取问答来源出错')
    console.log(err);
  });
}

export default {
  getOnlineLinks,
  addChannels,
  addBatchChannel,
  addChannelSubmission,
  cancelChannelSubmission,
  searchDataProcessing,
  getDistributionListData,
  empty,
  closeDialog,
  getGeneralLabel,
  getBusinessLabel,
  getDiseasesData,
  getBusiness,
  getContentNature,
  getDistributionScope,
  handleSelectionChange,
  storeInformation,
  initializeJump
}
